import { createFileRoute } from '@tanstack/react-router'

import DetailPoktanPage from '@/components/pages/backoffice/_klb-petani/_poktan/_$poktanId/containers/DetailPoktanPage'

export const Route = createFileRoute(
  '/_backoffice/klb-petani/poktan/$poktanId/'
)({
  component: DetailPoktanPage
})
